import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  if (state.url.startsWith('/verify')) return true;
  
  const token = localStorage.getItem('access_token');
  const tokenFromUrl = route.paramMap.get('token'); 

  console.log('Auth Guard - Token:', token);

  if (token !== null && token !== '') {
    return true;
  }

  // Redirect to login, preserve return URL
  return router.createUrlTree(['/verify'], {
    queryParams: {
      token: tokenFromUrl,
      returnUrl: state.url
    }
  });
};
